import React from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";
import GridEmpty from '../../../../../Utils/Grid/GridEmpty';
import { standardActions } from "../../../../../Utils/Grid/StandardActions";

const List = props => {

    const { data, loader, onSortChange, } = props;
    const { years_list } = data;
        if (!years_list || years_list.length === 0) {
            return <div>No hay datos disponibles para mostrar.</div>;
        }
    const dataExportable = data && data.investments && data.investments.results && Array.isArray(data.investments.results) ? data.investments.results : [];
    const formatearNumero = (dato) => {
        if (dato === null || dato === undefined || isNaN(dato)) {
            return '';
        }

        const formatoMoneda = new Intl.NumberFormat('es-GT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const numero = Number(dato);
        return "$ "+formatoMoneda.format(numero);
    }
    const columnaClaseTotal = (cell, row) => {
        if (row.name === 'Total') {
            return 'celda-totales';
        }
        return '';
    };

    const columnas = years_list.map((year, index) => (
        <TableHeaderColumn
            key={year}
            dataField={year}
            dataSort
            dataFormat={formatearNumero}
            columnClassName={columnaClaseTotal}
            width='130'
        >
            {year}
        </TableHeaderColumn>
    ));


    return (
        <GridEmpty
            hover
            striped
            data={dataExportable}
            loading={loader}
            onSortChange={onSortChange}
            pagination={false}
            className="pb-3"
            >
            <TableHeaderColumn
                dataField="name"
                dataSort
                columnClassName={columnaClaseTotal}
                isKey
                width='200'
            >
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="total"
                dataSort
                dataFormat={formatearNumero}
                columnClassName={columnaClaseTotal}
                width='200'
            >
                {/* Para tener el año en el que se esta haciendo el presupuesto. */}
                {years_list[0] - 1 }
            </TableHeaderColumn>

        </GridEmpty>
    );
};
export default List;